<template>
  <router-view></router-view>
  <!-- "Vedi come": qui e non in un layout, perche' launcher e pagine ne usano di diversi. -->
  <BandaVediCome v-if="guardaCome" />
</template>

<script>
import { defineAsyncComponent } from "vue";
import { appUpdate } from "@/services/appUpdate";
import toastService from "@/services/toastService";
import { vediCome } from "@/services/vediCome";

export default {
  name: "App",
  // A chi non sta guardando come nessuno la banda non si scarica nemmeno. Un cambio di stato ricarica sempre la pagina.
  components: {
    BandaVediCome: defineAsyncComponent(() => import(/* webpackChunkName: "vedi-come" */ "@/components/banda-vedi-come.vue")),
  },
  data() {
    return { guardaCome: vediCome.attivo() };
  },
  // Il controllo di un nuovo rilascio scatta al cambio pagina e quando si torna sulla
  // scheda: sono i momenti in cui l'utente e' davanti allo schermo. Nessun sondaggio a
  // intervalli, che consumerebbe richieste per niente.
  watch: {
    $route() {
      appUpdate.check();
    },
  },
  mounted() {
    // Il messaggio lasciato quando il "vedi come" si e' chiuso da solo: la pagina si e' ricaricata, e il
    // toast di allora si e' perso. Qui e non nella banda, che a quel punto non c'e' piu'.
    const avviso = vediCome.prendiAvviso();
    if (avviso) toastService.warning(avviso, "Vedi come");
    appUpdate.check();
    window.addEventListener("focus", this.alFuoco);
    document.addEventListener("visibilitychange", this.allaVista);
  },
  beforeUnmount() {
    window.removeEventListener("focus", this.alFuoco);
    document.removeEventListener("visibilitychange", this.allaVista);
  },
  methods: {
    alFuoco() {
      appUpdate.check();
    },
    allaVista() {
      if (document.visibilityState === "visible") appUpdate.check();
    },
  },
};
</script>
